/* @flow */

import * as React from 'react';
import glamorous from 'glamorous';

type Props = {
  darkMode: boolean,
  numCompleted: number,
  total: number,
};

const Headline = glamorous.div({
  alignItems: 'flex-end',
  display: 'flex',
});

const HeadlineFigure = glamorous.div(({ theme, green }) => ({
  color: green ? theme.color.green : theme.color.orange,
  flexBasis: 'auto',
  flexGrow: 0,
  flexShrink: 0,
  fontSize: '2.25rem',
  fontWeight: 'normal',
  lineHeight: 0.8,
}));

const HeadlineText = glamorous.div(({ darkMode, theme }) => ({
  color: darkMode ? theme.color.basis5 : theme.color.invertableBasis5,
  flexBasis: 0,
  flexGrow: 1,
  flexShrink: 1,
  fontSize: '0.6rem',
  paddingLeft: '0.5rem',
}));

function VerificationHeadline({ darkMode, numCompleted, total }: Props) {
  return (
    <Headline>
      <HeadlineFigure green={numCompleted === total}>
        {parseInt(numCompleted / total * 100, 10)}%
      </HeadlineFigure>
      <HeadlineText darkMode={darkMode}>
        {numCompleted === total ? 'Thanks!' : 'Current Completion'}
      </HeadlineText>
    </Headline>
  );
}

export default VerificationHeadline;
